import { Select } from "antd";
export const SelectUi = ({ data, ...props }) => {
  return <Select options={data} {...props} />;
};
